import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Helmet } from 'react-helmet';

import Layout from '../../../components/Checkout/Layout';
import Breadcrumb from '../../../components/Checkout/Breadcrumb';
import Summary from '../../../components/Checkout/Summary';
import Address from '../../../components/Checkout/Address';

import apiShipping from '../../../api/Shipping';

import Config, { spanish } from '../../../config/config';

const AddressPage = () => {
  const [content, setContent] = useState(false);
  const [referralIdForm, setReferralIdForm] = useState(null);
  const referralId = useSelector(
    (globalState) => globalState.referralInfo.referralId
  );
  const totalShippingCost = useSelector(
    (globalState) => globalState.shippingCost.totalShippingCost
  );
  const totalShippingTax = useSelector(
    (globalState) => globalState.shippingCost.shippingTax
  );

  useEffect(async () => {
    setContent(await apiShipping.getContent());
  }, []);
  const title = spanish ? content?.TitleSpanish : content?.TitleEnglish;
  return (
    <Layout>
      <Helmet
        title={spanish ? 'Dirección' : 'Address'}
        script={[
          {
            src: Config.payment_services.REF,
          },
        ]}
      />
      <Breadcrumb step={1} title={title} link="address" />
      <Address referalId={referralId} referralIdForm={referralIdForm} />
      <Summary
        edit
        shippingCost={totalShippingCost}
        shippingTax={totalShippingTax}
        setReferalId={setReferralIdForm}
        referralId={referralId}
        referralIdForm={referralIdForm}
      />
    </Layout>
  );
};

export default AddressPage;
